export default class VoidStorage {
  storage;

  constructor() {
    this.storage = {};
  }

  getItem(item) {
    return this.storage[item];
  }

  removeItem(item) {
    return Object.keys(this.storage).reduce((acc, key) => {
      if (key !== item) {
        acc[key] = this.storage[key];
      }
      return acc;
    }, {});
  }

  setItem(name, value) {
    this.storage[name] = value;
  }

  clear() {
    this.storage = {};
  }
}

// export default { VoidStorage };
